__turbopack_context__.v({
  "badge": "ParagraphStoryCard-module__r85lDW__badge",
  "body": "ParagraphStoryCard-module__r85lDW__body",
  "card": "ParagraphStoryCard-module__r85lDW__card",
  "cardLeft": "ParagraphStoryCard-module__r85lDW__cardLeft",
  "cardRight": "ParagraphStoryCard-module__r85lDW__cardRight",
  "cardSubtitle": "ParagraphStoryCard-module__r85lDW__cardSubtitle",
  "cardTitle": "ParagraphStoryCard-module__r85lDW__cardTitle",
  "cta": "ParagraphStoryCard-module__r85lDW__cta",
  "eyebrow": "ParagraphStoryCard-module__r85lDW__eyebrow",
  "header": "ParagraphStoryCard-module__r85lDW__header",
  "image": "ParagraphStoryCard-module__r85lDW__image",
  "intro": "ParagraphStoryCard-module__r85lDW__intro",
  "quote": "ParagraphStoryCard-module__r85lDW__quote",
  "quoteFooter": "ParagraphStoryCard-module__r85lDW__quoteFooter",
  "quoteText": "ParagraphStoryCard-module__r85lDW__quoteText",
  "section": "ParagraphStoryCard-module__r85lDW__section",
  "statItem": "ParagraphStoryCard-module__r85lDW__statItem",
  "statLabel": "ParagraphStoryCard-module__r85lDW__statLabel",
  "statValue": "ParagraphStoryCard-module__r85lDW__statValue",
  "stats": "ParagraphStoryCard-module__r85lDW__stats",
  "title": "ParagraphStoryCard-module__r85lDW__title",
});
